export interface CreditCheckDetails {
  type: string;
  reference: string;
  additionalReference: string;
  date: Date;
  totalAmount: number;
  totalPaid: number;
  dueDate: Date;
  datePaid: Date;
  daysLate: number;
  status: string;
  overdueStatus: string;
}
